import React, {useContext, useEffect, useState} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import Stack from '@mui/material/Stack';
import Dropzone from '../Chat/Dropzone.js';
import {getVPCService, isMobile, matchesAnyRegex} from "../App/utils.js";
import {AlertContext} from "../App/App.js";
import {inputTools} from "./constant.js";
import {uploadFileAPI} from "../API/KB/Files.js";

const types = [
    "image/jpeg",
    "image/pjpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/tiff",
    "image/svg+xml",
    "image/x-icon",
    "application/pdf",
];
export const VisionImageUpload = ({ style, setBlockingLoading, onSuccess = () => {}, renderSettings }) => {
    const {setSystemAlert} = useContext(AlertContext);

    const onFileUpload = async (event) => {
        let selectedFile = event instanceof File ? event : event.target.files[0];

        if (!selectedFile?.type) return;
        if (!matchesAnyRegex(selectedFile.type, types)) {
            setSystemAlert({msg: 'Invalid file type', type: 'error', duration: 3000})
            return;
        }

        if (selectedFile.type && selectedFile.type?.includes('pdf')) {
            selectedFile = new File([selectedFile], `file-${Math.round(+new Date()/1000)}.pdf`, { type: selectedFile.type });
        } else {
            selectedFile = new File([selectedFile], `image-${Math.round(+new Date()/1000)}.jpg`, { type: selectedFile.type });
        }

        if (!selectedFile) {
            setSystemAlert({msg: 'Please select image to upload', type: 'error', duration: 3000})
            return;
        }

        try {
            setBlockingLoading(1);
            const response = await uploadFileAPI(selectedFile, 'files', (percentage) => {
                setBlockingLoading(percentage);
            });

            let uploadedURL = response?.request?.responseURL?.split('?')?.[0];

            uploadedURL = uploadedURL.replace('https://openkbs-files-raw-accelerate.s3.amazonaws.com/', (getVPCService('file') || 'https://file.openkbs.com/'))

            setBlockingLoading(false);

            if (uploadedURL) onSuccess(uploadedURL)

        } catch (e) {
            setBlockingLoading(false)
            alert('Error during upload');
            console.error(e);
        }

        if(event?.target?.value) event.target.value = null;
    }

    const visionImageUploadLabel = renderSettings?.permanentImageUploadLabel || inputTools.visionImageUpload.label;

    return (
        <Stack alignItems="center" spacing={2} style={style} >
            <Dropzone onFileUpload={onFileUpload} types={types} id={"uploadFile"}/>

            <Tooltip title={visionImageUploadLabel} open={!!renderSettings?.permanentImageUploadLabel} placement="top">
                <IconButton color="primary" aria-label={visionImageUploadLabel} component="label">
                    <input hidden type="file" onChange={onFileUpload} />
                    {isMobile
                        ? (
                            renderSettings?.imageUploadMobileIcon?.() ||
                            inputTools.visionImageUpload.iconMobile({
                                label: renderSettings?.permanentImageUploadLabel
                            })
                        )
                        : inputTools.visionImageUpload.icon()
                    }
                </IconButton>
            </Tooltip>
        </Stack>
    );
}